// removed by extract-text-webpack-plugin
module.exports = {"cardImage":"HorizontalCardImage__cardImage__33WWU"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/HorizontalCardGrid/HorizontalCard/HorizontalCardImage/HorizontalCardImage.scss
// module id = 1690
// module chunks = 0